export default __webpack_public_path__ + "static/media/audi.8a404a71.svg";